import { render, staticRenderFns } from "./RichTextArea.vue?vue&type=template&id=79e88dbd&"
import script from "./RichTextArea.vue?vue&type=script&lang=js&"
export * from "./RichTextArea.vue?vue&type=script&lang=js&"
import style0 from "./RichTextArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports